var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSideright3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1091,
    height: 843,
    viewBox: "0 0 1091 843",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1091,
    height: 857,
    fill: "#508C9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSideright3);
export default __webpack_public_path__ + "static/media/sideright3.4863563b5e3eff6b718c5d9b34b19c18.svg";
export { ForwardRef as ReactComponent };